<template>
  <div>
    <b-card no-body>
      <b-card-header>
        <div class="d-flex justify-content-between">
          <h3 class="mb-0">Vendors</h3>
          <b-button size="sm" variant="danger" v-b-modal.vendor-modal v-if="!roles.includes('enterprise')">Add Vendor</b-button>
        </div>
      </b-card-header>
      <b-table responsive small no-sort-reset :items="vendors" :fields="fields">
        <template #cell(actions)="row">
          <b-dropdown text="Actions" size="sm" variant="info" boundary="viewport">
            <b-dropdown-item variant="primary" @click="handleEdit(row)"><i class="fa fa-edit"></i> Edit</b-dropdown-item>
            <b-dropdown-item variant="danger" @click="handleDelete(row)"><i class="fa fa-trash"></i> Delete</b-dropdown-item>
          </b-dropdown>
        </template>
        <template #cell(active)="row">
          <i class="fas fa-check" v-if="row.item.active"></i>
          <i class="fas fa-times text-danger" v-else></i>
        </template>
        <template #cell(logo)="row">
          <b-button size="sm" variant="primary" :href="'https://vapor-us-east-1-1603342423.s3.amazonaws.com/' + row.item.logo" target="_blank" v-if="row.item.logo">View Logo</b-button>
        </template>
      </b-table>
    </b-card>
    <vendor-modal :userRoute="userRoute" :slug="slug" :enterprise_id="enterprise_id" @getVendors="getVendors" @clearSlug="clearSlug"></vendor-modal>
  </div>
</template>

<script>
import axios from 'axios';
import { mapGetters } from 'vuex';
import VendorModal from '@/views/Components/Modals/VendorModal';
import errorsMixin from '@/mixins/errors-mixin';

export default {
  mixins: [errorsMixin],
  components: {
    VendorModal
  },
  props: {
    enterprise_id: null,
    userRoute: null
  },
  data() {
    return {
      vendors: [],
      fields: [
        {
          key: 'actions',
          sortable: false
        },
        {
          key: 'name',
          sortable: true
        },
        {
          key: 'url',
          sortable: false
        },
        {
          key: 'logo',
          sortable: false
        },
        {
          key: 'order',
          sortable: true
        },
        {
          key: 'active',
          sortable: false
        }
      ],
      slug: null
    }
  },
  computed: {
    ...mapGetters({
      roles: 'roles/roles'
    })
  },
  methods: {
    async getVendors() {
      await axios.get(this.userRoute + "/vendors?enterprise_id=" + this.enterprise_id)
      .then(response => {
        this.vendors = response.data;
      })
      .catch(error => {
        this.error(error);
      });
    },
    handleEdit(vendor) {
      this.slug = vendor.item.slug;
      this.$bvModal.show('vendor-modal')
    },
    async handleDelete(vendor) {
      await axios.delete(this.userRoute + "/vendors/" + vendor.item.slug)
      .then(response => {
        this.getVendors();
      })
      .catch(error => {
        this.error(error);
      });
    },
    clearSlug() {
      this.slug = null;
    }
  },
  created() {
    this.getVendors();
  }
};
</script>